import React from "react";
import { useHistory } from "react-router";
import homepic from "../Assets/homepic.png";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles((theme) => ({
  button: {
    color: theme.palette.common.white,
    fontWeight: "bold",
  },
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  pic: {
    float: "left",
    width: "940px",
  },
}));

const Home = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Grid container justify="center" alignItems="center">
      <Grid item lg={5}>
        <img src={homepic} alt="Doctors" className={classes.pic} />
      </Grid>
      <Grid item lg={7} className={classes.root}>
        <Typography component="div">
          <Box
            display="block"
            fontSize={38}
            fontWeight="fontWeightBold"
            letterSpacing={1}
            color="primary.main"
            textAlign="right"
            m={3}
          >
            LET'S HELP EACH OTHER <br /> AGAINST COVID-19 CRISIS
          </Box>
          <Box
            display="block"
            fontSize={20}
            fontWeight={410}
            letterSpacing={0.7}
            color="primary.main"
            textAlign="right"
            component="p"
            m={3}
          >
            We are here to provide a platform for you to participate
            <br />
            in the fight against COVID-19 by the use of online discussions,
            <br />
            queries, and assessment of your personal risk status to the disease.
          </Box>
          <Box display="flex" alignItems="center" justifyContent="center" m={3}>
            <Button
              className={classes.button}
              variant="contained"
              color="primary"
              size="large"
              onClick={() => history.push("/forum/main")}
            >
              FORUM
            </Button>
          </Box>
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Home;
